<template>
    <div id="chat-viewer" :key="selectedChatClone._id">
        <div class="user-info-head">
            <span class="head-right">
                <Avatar
                    :size="40"
                    :username="getName() || ''"
                    :src="getAgentImage()"
                    class="sc-message--avatar"
                    style="color: white; font-size: 15px; min-width: 40px !important"
                />
                <span class="user-info">
                    <div class="user-name">
                        {{ getName() }}
                    </div>
                    <div class="user-mail-tel-head">
                        <span class="user-mail-tel">{{ getEmail() }} </span>
                    </div>
                </span>
            </span>
            <span style="margin-right: 20px">
                <!--                <span class="material-icons">videocam</span>-->
                <span class="material-icons ml-4">search</span>
                <!--                <span class="material-icons ml-4" style="color: #ffcf6d">star</span>-->
            </span>
        </div>
        <div
            class="messageListContainer"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragover="dragOver"
            @drop="dropBlock"
            @paste="handleTPaste"
        >
            <MessageList
                v-if="!dragMode"
                :always-scroll-to-bottom="true"
                :scroll-top="false"
                :colors="colors"
                :is-private-chat="true"
                :messages="getMessages()"
                :random-bg-color-with-name="true"
                :participants="[{ _id: 1, name: 'John Doe' }]"
                :show-avatar="true"
                :show-typing-indicator="$t('message.customerTyping')"
                :ischatwindow="true"
                :disable-translation="true"
                :contextMenuVisable="false"
                :firstUnreadMessage="getFirstUnreadMessage()"
            />
            <div v-else class="dnd">
                <h1 style="align-items: center; color: grey">Choose a file or drag it here!</h1>
            </div>
        </div>
        <div class="uploading-wrapper" v-if="show">
            <span> {{ uploadPercentage }}% uploaded... please wait</span>
            <a-progress :showInfo="false" :percent="uploadPercentage" status="active" />
        </div>
        <div style="position: relative">
            <quill-editor
                style="max-height: 14%"
                ref="myQuillEditor"
                v-model="content"
                id="chat-editor"
                @blur="onEditorBlur($event)"
                @ready="onEditorReady($event)"
                @change="onEditorChange($event)"
                :options="editorOption"
            />

            <div id="toolbar" slot="toolbar" style="position: absolute; z-index: 999; top: 0; right: 0">
                <div class="voice-message">
                    <VoiceRecorder :cb="sendVoiceMessage" />
                </div>
                <md-button class="file-message" @click="selectFile">
                    <md-icon>attachment</md-icon>
                </md-button>
                <md-button @click="sendMessage" id="send-btn">
                    <send-icon />
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SendIcon from "../../../components/svg/SendIcon";
import MessageList from "../../../components/popup-chat/MessageList.vue";

import { log2 } from "../../../utils/log2";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { filter, map } from "rxjs/operators";
import * as _ from "lodash";
import { toNewMessagesModel } from "../../../utils/chat";
import { sendDesktopNotification } from "../../../utils/desktopNotification";
import { newPrivateMessage } from "../../../utils/notificationSounds";
import { uploadAsset } from "../../../api/assetUpload";
import axios from "axios";
import VoiceRecorder from "../../../components/VoiceRecorder";
import { getExtensionFromFileName } from "../../../utils/utils";
import mimeTypes from "../../../components/util/mimeTypes";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import Avatar from "vue-avatar";
import moment from "moment";

const log = log2("ChatViewer");

export default {
    name: "ChatViewer",
    components: {
        SendIcon,
        MessageList,
        VoiceRecorder,
        Avatar,
    },
    props: {
        newGroup: {
            type: Boolean,
            required: true,
            default: () => false,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        defaultMessage: {
            type: String,
            default: "",
        },
    },
    data(props) {
        console.log("ChatViewer", props.defaultMessage);

        return {
            messages: [],
            show: false,
            uploadPercentage: 0,
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            keyboardBindings: [],
            page: 1,
            unreadBtn: false,
            content: props.defaultMessage,
            editorOption: {
                // Some Quill options...
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        ["link"],
                    ],
                },
            },
            dragMode: false,
            selectedChatClone: {},
            getMessageChatType: "",
            thread: [],
            unreadMessageCount: 0,
        };
    },
    computed: {
        ...mapState({
            userInteracted: (state) => () => state.app.userInteracted,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            privateChatIsMuted: (state) => state.app.privateChatIsMuted,
            selectedChat: (state) => state.team.selectedChat,
            isTeam: (state) => _.get(state.team.selectedChat, "meta.chatType") === "team",
            chats: (state) => state.team.chats,
            chatsHash: (state) => state.team.chats.reduce((acc, chat) => ({ ...acc, [chat._id]: chat }), {}),
            users: (state) => state.user.users.data,
            unreadCountMessage: (state) => state.team.unreadMessages,
        }),
        ...mapGetters({
            getUser: "user/getUser",
            isNotificationMute: "team/isNotificationMute",
        }),
    },
    methods: {
        ...mapActions({
            setLoadingState: "team/setLoadingState",
            updateChatLastMessage: "team/updateChatLastMessage",
            getLoadingFilePercent: "team/getLoadingFilePercent",
            getLoadingState: "team/getLoadingState",
            loadOldHistoryMessages: "chat/loadOldHistoryMessages",
            updateUnreadMessageCount: "team/updateUnreadMessageCount",
            increaseUnreadMessageCount: "team/increaseUnreadMessageCount",
        }),
        getFirstUnreadMessage() {
            let userMessages = this.messages.filter((message) => message.messageType === "user");
            let unreadMessage = userMessages[userMessages.length - this.unreadMessageCount];
            return unreadMessage;
        },
        getUnreadMessageCount(data) {
            const indexUnreadMessage = this.unreadCountMessage.findIndex((item) => item.chatId === data._id);
            if (indexUnreadMessage !== -1) return this.unreadCountMessage[indexUnreadMessage].unreadCount;
            return 0;
        },
        focusEditor() {
            if (this.$refs.myQuillEditor) {
                this.$refs.myQuillEditor.quill.focus();
            }
        },
        dragEnter(e) {
            this.dragMode = true;
        },
        dragLeave() {
            this.dragMode = false;
        },
        async dropBlock(ev) {
            this.dragMode = false;
            ev.preventDefault();
            const files = _.get(ev, "dataTransfer.files");
            if (files && files.length > 0) {
                const chat_id = this.selectedChat._id;
                for (let i = 0; i < files.length; i++) {
                    let uploadFile = {
                        chat_id: chat_id,
                        fileNumber: Math.random(),
                        finished: false,
                        percent: 0,
                        failed: false,
                    };
                    await this.uploadFile(files[i], uploadFile);
                    ev.stopPropagation();
                }
            }
        },
        dragOver(ev) {
            ev.preventDefault();
        },
        async handleTPaste(event) {
            event.preventDefault();
            const files = _.get(event, "clipboardData.files");
            if (files && files.length > 0) {
                const chat_id = this.selectedChat._id;
                for (let i = 0; i < files.length; i++) {
                    let uploadFile = {
                        chat_id: chat_id,
                        fileNumber: Math.random(),
                        finished: false,
                        percent: 0,
                        failed: false,
                    };
                    await this.uploadFile(files[i], uploadFile);
                    event.stopPropagation();
                }
                return true;
            }
        },
        onEditorBlur(quill) {
            log.debug("editor blur!", quill);
        },
        onEditorReady(quill) {
            log.debug("editor ready!", quill);
            this.keyboardBindings.forEach((f) => {
                document.removeEventListener("keydown", f);
            });
            this.keyboardBindings = [];
            const f = (e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                    if (_.get(e.srcElement, "className") === "ql-editor") {
                        log.debug("send message!", e.srcElement);
                        this.sendMessage();
                    }
                }
            };
            document.addEventListener("keydown", f);
            this.keyboardBindings.push(f);
        },
        onEditorChange({ quill, html, text }) {
            log.debug("editor change!", { a: quill, b: html, c: text });
            this.content = html;
            const emitUsers = this.getEmitUsers(this.selectedChat.meta);
            this.content = this.content.replaceAll("<p><br></p>", "");
            sendSocketMessage("team typing-message", {
                emitUsers,
                message: this.content,
                chatId: this.selectedChat._id,
                userName: this.user.name,
                ts: Date.now(),
            });
            this.draftMessage = html;

            clearTimeout(this.draftMessageTimer);
            this.draftMessageTimer = setTimeout(() => {
                const chatId = _.get(this.selectedChat, "_id");
                if (chatId) {
                    localStorage.setItem(`draftMessage_${chatId}`, this.draftMessage);
                }
            }, 1000);
        },
        getEmitUsers(meta) {
            const chatType = meta.chatType;
            if (chatType === "thread") {
                if (meta.thread.agent1._id === this.user._id) {
                    return [meta.thread.agent2._id];
                } else if (meta.thread.agent2._id === this.user._id) {
                    return [meta.thread.agent1._id];
                }
            } else if (chatType === "team") {
                let users = this.users.map((user) => user._id);
                users = users.filter((user) => user !== this.user._id);
                return users;
            } else if (chatType === "department") {
                const result = this.users
                    .filter((user) => user.subjects.includes(meta.department._id) || user.subjects.length === 0)
                    .map((user) => user._id);
                return result.filter((user) => user !== this.user._id);
            } else if (chatType === "groupThread") {
                const users = meta.groupThread.agents
                    .map((agent) => agent._id)
                    .filter((user) => user !== this.user._id);
                if (meta.groupThread.creator._id !== this.user._id) {
                    users.push(meta.groupThread.creator._id);
                }
                return users;
            }
        },
        getName() {
            if (!this.selectedChat) return;
            const chat = this.selectedChat.meta;
            if (chat.chatType === "groupThread") {
                return chat.groupThread.title;
            } else if (chat.chatType === "thread") {
                if (chat.thread.agent2._id === this.user._id) {
                    return chat.thread.agent1.name;
                }
                return chat.thread.agent2.name;
            } else if (chat.chatType === "department") {
                return chat.department.languageContent[0].name;
            } else {
                return chat.chatType.toUpperCase();
            }
        },
        getAgentImage() {
            if (!this.selectedChat) return "";

            const chat = this.selectedChat.meta;
            const agent1Id = chat?.thread?.agent1?._id;
            const agent2Id = chat?.thread?.agent2?._id;

            if (agent2Id === this.user?._id) {
                return chat?.thread?.agent1?.gravatar || "";
            } else if (agent1Id === this.user?._id) {
                return chat?.thread?.agent2?.gravatar || "";
            } else {
                return chat?.groupThread?.groupProfilePicture || "";
            }
        },
        getEmail() {
            if (!this.selectedChat) return;
            const chat = this.selectedChat.meta;
            if (chat.chatType === "thread") {
                if (chat.thread.agent2._id === this.user._id) {
                    return chat.thread.agent1.email;
                }
                return chat.thread.agent2.email;
            } else {
                return chat.chatType;
            }
        },
        playNotificationSound: _.debounce(function (isReceive = false) {
            if (isReceive) {
                if (this.privateChatIsMuted) return;
                if (this.userInteracted()) {
                    sendDesktopNotification(this.$t("message.betweenRepresentative"), 1);
                    newPrivateMessage(this.getMessageChatType).play();
                }
            }
        }, 1000),
        sendMessage(event) {
            this.content = this.content.replaceAll("<p><br></p>", "");
            if (this.content.length > 0) {
                const payload = {
                    conversationId: this.selectedChat._id,
                    message: this.content,
                    siteId: this.site._id,
                    userId: this.user._id,
                    username: this.user.name,
                };
                sendSocketMessage("team message", payload);
                this.content = "";
            }
        },
        async uploadFile(file, uploadFile) {
            const fileType = getExtensionFromFileName(file.name);

            let path = `${this.site._id}/file/${this.selectedChat._id}`;

            let { data } = await uploadAsset({
                path,
                mime: file.type,
                name: file.name,
                ext: mimeTypes[file.type] || fileType || "supsis",
                size: file.size,
                type: "team-chat",
            });
            if (file.size <= 10 * 1024 * 1024) {
                const socketFeedbackMessage = {
                    conversationId: this.selectedChat._id,
                    userId: this.user._id,
                    username: this.user.name,
                    siteId: this.site._id,
                    asset: data.asset,
                };
                await axios({
                    method: data.method,
                    url: data.url,
                    data: file,
                    headers: {
                        "Content-Type": file.type,
                    },
                    onUploadProgress: await function (progressEvent) {
                        const percent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        uploadFile.percent = percent;
                        this.setLoadingState(uploadFile);
                        this.getLoadingFilePercent(this.selectedChat._id).then((percent) => {
                            this.uploadPercentage = percent;
                            this.show = !!percent;
                        });
                    }.bind(this),
                })
                    .then((result) => {
                        this.show = false;
                        uploadFile.finished = true;
                        this.uploadPercentage = 0;
                        this.setLoadingState(uploadFile);
                        this.getLoadingState(uploadFile.fileNumber).then((result) => {
                            sendSocketMessage("team media-message", socketFeedbackMessage);
                        });
                    })
                    .catch((err) => {
                        this.show = false;
                        uploadFile.failed = true;
                        this.setLoadingState(uploadFile);
                    });
            } else {
                log.warn("input is not suitable for send");
                this.$toasted.error(this.$t("message.assetOversize"), {
                    duration: 3000,
                    position: "bottom-center",
                });
            }
        },
        async selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                let uploadFile = {
                    chat_id: this.selectedChat._id,
                    fileNumber: Math.random(),
                    finished: false,
                    percent: 0,
                    failed: false,
                };
                await this.uploadFile(file, uploadFile);
            };
            fileEl.click();
        },
        addMessage(data) {
            log("addMessage", data);
            let items = [...this.messages, data];
            items = _.orderBy(
                _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                ["createdDate"],
                ["asc"]
            );
            this.messages = items;
        },
        addMultiMessage(messages) {
            let items = [...this.messages, ...messages];
            items = _.orderBy(
                _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                ["createdDate"],
                ["asc"]
            );
            this.messages = items;
        },
        setMessages(conversationId, newMessageList, resyncMode = false) {
            const createdDate = moment(this.chatsHash[conversationId].createdDate).format("YYYY-MM-DD");
            this.addMessage({
                messageType: "load-more",
                conversationId: conversationId,
                createdDate: createdDate,
                uniqMessageId: "load-more",
            });
            this.addMultiMessage(newMessageList);
        },
        getMessages() {
            const msgs = _.uniqBy(_.sortBy(this.messages, "createdDate"), "uniqMessageId");
            const result = toNewMessagesModel(msgs, this, false, true, _.get(this.user, "_id"));
            const processedMessages = result.reduce((acc, message, index) => {
                const createdDate = moment(message.raw.createdDate).format("YYYY-MM-DD");
                const prewMessageDate =
                    result[index - 1] && moment(result[index - 1].raw.createdDate).format("YYYY-MM-DD");
                const prewMessage = result[index - 1] || {};

                if (createdDate !== prewMessageDate && prewMessage !== result[0]) {
                    acc.push({
                        type: "day-separator",
                        raw: {
                            messageType: "day-separator",
                            systemMessageType: "day-separator",
                            createdDate: createdDate,
                            uniqMessageId: createdDate,
                            _id: createdDate,
                        },
                        description: createdDate,
                    });
                }
                acc.push(message);
                return acc;
            }, []);

            return processedMessages;
        },
        async sendVoiceMessage(blob) {
            let path = `${this.site._id}/voice/${this.selectedChat._id}`;
            const mimeType = "audio/mpeg";
            const ext = "mp3";
            const size = blob.size;
            let { data } = await uploadAsset({ path, mime: mimeType, ext, size, type: "team-chat" });
            await axios({
                method: data.method,
                url: data.url,
                data: blob,
                // headers: { "Content-Type": "application/octet-stream" },
                headers: { "Content-Type": mimeType },
            });
            console.log("sendVoiceMessage", {
                path,
                data,
                blob,
                mimeType,
                userName: this.user.name,
                siteId: this.site._id,
                asset: data.asset,
                conversationId: this.selectedChat._id,
                userId: this.user._id,
            });
            sendSocketMessage("team media-message", {
                conversationId: this.selectedChat._id,
                userId: this.user._id,
                username: this.user.name,
                siteId: this.site._id,
                asset: data.asset,
            });
            log("sendVoiceMessage", { blob, data });
        },
        syncMessages(conversationId, cache = false) {
            if (!!conversationId) {
                return this.loadOldHistoryMessages({ conversationId, cache }).then((newMessageList) => {
                    this.setMessages(conversationId, newMessageList);
                    const unreadMessage = this.getFirstUnreadMessage();
                    if (unreadMessage) {
                        const unreadMessageId = unreadMessage.uniqMessageId || unreadMessage._id;
                        setTimeout(() => {
                            const unreadMessageElement = document.getElementById(`sc-message_${unreadMessageId}`);
                            if (unreadMessageElement) {
                                unreadMessageElement.scrollIntoView({
                                    behavior: "smooth",
                                });
                                unreadMessageElement.classList.add("first-unread-message");
                                setTimeout(() => {
                                    unreadMessageElement.classList.remove("first-unread-message");
                                }, 1000);
                            }
                        }, 700);
                    }
                });
            }
        },
        listenLoadMore() {
            log("load more subscriber added");
            this.loadMoreSubscriber = SYSTEM_PUBSUB.stream
                .pipe(filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.TEAM_CONVERSATION_LOAD_MORE))
                .subscribe(async () => {
                    log("load more clicked");
                    const conversationId = _.get(this.selectedChat, "_id");
                    this.syncMessages(conversationId, false).finally(() => {
                        try {
                            document.getElementsByClassName("sc-message-list")[0].scrollTop = 0;
                        } catch (e) {
                            log.error("scroll error", e);
                        }
                    });
                });
        },
    },
    beforeDestroy() {
        if (!!this.loadMoreSubscriber) {
            this.loadMoreSubscriber.unsubscribe();
        }
        if (!!this.messageSubscriber) {
            this.messageSubscriber.unsubscribe();
        }
    },
    async mounted() {
        this.focusEditor();
        this.messageSubscriber = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "message"),
                map((x) => x.data)
            )
            .subscribe(async (message) => {
                message = {
                    ...message,
                };
                if (message.conversationId === this.selectedChat._id) {
                    this.messages.push(message);
                }
            });
        this.listenLoadMore();
        this.page = 1;
        this.syncMessages(_.get(this.selectedChat, "_id"));
        this.selectedChatClone = _.clone(this.selectedChat);
    },

    watch: {
        defaultMessage(val) {
            console.log("defaultMessage changed", val);
            this.content = val;
        },
        scrollTop(val) {},
        visible(val) {
            if (val === true) {
                this.updateUnreadMessageCount({
                    oldChatId: null,
                    newChatId: this.selectedChat._id,
                    userId: this.user._id,
                });
            }
        },
        selectedChat: {
            handler: async function (newChat, oldChat) {
                if (newChat) {
                    this.focusEditor();
                    this.unreadMessageCount = this.getUnreadMessageCount(newChat);
                }
                if (oldChat) {
                    const oldChatId = oldChat._id;
                    localStorage.setItem(`draftMessage_${oldChatId}`, this.content);
                }

                this.content = this.defaultMessage;

                const emitUsers = this.getEmitUsers(oldChat.meta);
                sendSocketMessage("team typing-message", {
                    emitUsers,
                    message: this.content,
                    chatId: oldChat._id,
                    userName: this.user.name,
                });

                if (newChat) {
                    const newChatId = newChat._id;
                    const savedDraftMessage = localStorage.getItem(`draftMessage_${newChatId}`);
                    if (savedDraftMessage) {
                        this.content = savedDraftMessage;
                    }
                    await this.updateUnreadMessageCount({
                        oldChatId: oldChat._id,
                        newChatId: newChat._id,
                        userId: this.user._id,
                    });
                    this.messages = [];
                    this.syncMessages(newChat._id, true);
                } else {
                    this.messages = [];
                }
            },
            deep: true,
        },
        messages: {
            handler: function (newChat, oldChat) {
                console.log("unread", this.getFirstUnreadMessage());
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.first-unread-message {
    background-color: #e3fcef !important;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0;
    height: 100px;
}

#toolbar {
    display: flex;
    height: 30%;
    align-items: center;
    justify-items: center;

    .voice-message {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;
        margin-right: 5px;

        #voiceRecorder {
            .actionBtn {
                width: 15px;
                margin-right: 3px;
            }
        }
    }

    .file-message {
        margin: 0;
        width: auto;
        min-width: 24px;
        height: 100%;
    }

    #send-btn {
        min-width: 40px;
        width: auto;
        height: 100%;
        margin: 0;

        .md-ripple {
            .md-button-content {
                display: flex !important;
            }
        }
    }
}

#chat-editor {
    .ql-formats {
        #ql-picker-options-4 {
            height: 100px !important;
            overflow-y: scroll !important;
        }
    }

    .ql-editor {
        max-width: 47vw !important;
    }
}
</style>
<style lang="scss" scoped>
#chat-viewer {
    max-height: 100% !important;
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: space-between;

    .uploading-wrapper {
        background: white;
        justify-content: center;
        display: flex;
        flex-wrap: wrap;

        .ant-progress-line {
            justify-content: center;
            display: flex;

            .ant-progress-inner {
                width: 350px;

                .ant-progress-bg {
                    width: 350px;
                }
            }
        }
    }

    .messageListContainer {
        height: calc(100% - 87px - 150px);
        position: relative;

        .dnd {
            background-image: linear-gradient(90deg, silver 50%, transparent 50%),
                linear-gradient(90deg, silver 50%, transparent 50%), linear-gradient(0deg, silver 50%, transparent 50%),
                linear-gradient(0deg, silver 50%, transparent 50%);
            background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
            background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
            background-position: left top, right bottom, left bottom, right top;
            animation: border-dance 1s infinite linear;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }

        @keyframes border-dance {
            0% {
                background-position: left top, right bottom, left bottom, right top;
            }
            100% {
                background-position: left 15px top, right 15px bottom, left bottom 15px, right top 15px;
            }
        }
    }

    .user-info-head {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f2f2f2;
        padding: 10px;

        .head-right {
            display: flex;
            align-items: center;
            max-width: 90%;

            .user-segment-avatar {
                height: 55px;
                width: 55px;
                display: flex;
                align-items: center;
                font-size: 16px;
                background: #6899c1;
                border-radius: 50%;
                margin: 5px;
            }

            .user-info {
                max-width: 90%;

                .user-name {
                    font-weight: 800;
                    font-size: large;
                    max-width: 100%;
                    word-wrap: break-word;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-wrap: nowrap;
                }

                .user-mail-tel-head {
                    margin-top: 5px;

                    .user-mail-tel {
                        font-weight: 300;
                    }
                }
            }
        }
    }
}
</style>
